<template>
    <div class="card shadow my-2 bg-body rounded h-auto py-4 px-3 py-md-4 px-md-5">
        <div class="mb-3">
            <div class="row" role="group">
                <h3 class="text-center">Select The Product You Want To Refresh Offers For</h3>
                <div v-if="this.isPhoneConfirmed || !this.hasFailedPhoneConfirmation" class="btn-group btn-group-lg col-12">
                    <a class="btn btn-primary mt-4 py-4 btn-select-product"
                       @click="this.$emit('selectedProduct', 'personal_loan')"
                   >
                        <span>Personal Loan</span>
                    </a>
                </div>
                <div v-if="this.isPhoneConfirmed || !this.hasFailedPhoneConfirmation" class="btn-group btn-group-lg col-12">
                    <a class="btn btn-primary mt-4 py-4 btn-select-product"
                       @click="this.$emit('selectedProduct', 'car_loan')"
                    >
                        <span>Car Loan</span>
                    </a>
                </div>
<!--                <div v-if="this.isPhoneConfirmed || !this.hasFailedPhoneConfirmation" class="btn-group btn-group-lg col-12">-->
<!--                    <a class="btn btn-primary mt-4 py-4 btn-select-product"-->
<!--                       @click="this.$emit('selectedProduct', 1_click_application')"-->
<!--                    >-->
<!--                        <span>1-Click Application</span>-->
<!--                    </a>-->
<!--                </div>-->
                <div class="btn-group btn-group-lg col-12">
                    <a class="btn btn-primary mt-4 py-4"
                       @click="this.$emit('selectedProduct', 'other_offers')"
                    >
                        <span>Credit Building</span>
                    </a>
                </div>
                <div v-if="this.hasFailedPhoneConfirmation" class="btn-group btn-group-lg col-12">
                    <a class="btn btn-primary mt-4 py-4"
                       href="/loan"
                       target="_blank"
                    >
                        <span>Start New Application</span>
                    </a>
                </div>
                <div class="btn-group btn-group-lg col-12">
                    <a class="btn btn-primary mt-4 py-4"
                       :href="this.$parent.settings.memberPortalUrl"
                       target="_blank"
                       style="opacity: 0.60;"
                    >
                        <span>Free Credit Score</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ProductSelection',
    emits: ['selectedProduct'],
    props: {
        isPhoneConfirmed: {
            type: Boolean,
            required: true,
            default: false,
        },
        hasFailedPhoneConfirmation: {
            type: Boolean,
            required: true,
            default: false,
        }
    },
    data() {
        return {
        }
    },
    methods: {
    }

}
</script>
